import pl from "@locales/program_pdf/pl.json";
import en from "@locales/program_pdf/en.json";

export default {
  pl: pl,
  en: en,
};
